import React from 'react';
import { StyledPopover } from './style';
import { useSystemSettingState } from 'contexts/SystemSettingContext';

type ActionType = 'hover' | 'focus' | 'click' | 'contextMenu';

export interface PopoverProps {
  children: React.ReactNode;
  content: React.ReactNode;
  trigger: ActionType | ActionType[];
  title?: string;
  className?: string;
  open?: boolean;
  overlayInnerStyle?: any;
  onOpenChange?: (open: boolean) => void;
  ignoreDevice?: boolean;
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom';
}

export const Popover = ({
  children,
  content,
  trigger,
  title,
  className,
  open,
  placement,
  overlayInnerStyle,
  onOpenChange,
  ignoreDevice = false,
}: PopoverProps) => {
  const {
    device: { isDesktop },
  } = useSystemSettingState();

  const mainApp: any = document.getElementsByClassName('App')[0];
  const deviceOpenState = isDesktop ? open : false;

  return (
    <StyledPopover
      content={content}
      trigger={trigger}
      title={title}
      getPopupContainer={() => mainApp}
      className={className}
      open={ignoreDevice ? open : deviceOpenState}
      placement={placement}
      overlayInnerStyle={overlayInnerStyle}
      onOpenChange={onOpenChange}
    >
      {children}
    </StyledPopover>
  );
};
